import { IoClose } from "react-icons/io5";
import { resolveMediaUrl } from "../../../../utility/media";

const ViewResolutionDetailsModal = ({ isOpen, onClose, resolution }) => {
    if (!isOpen || !resolution) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '900px', maxWidth: '95%' }}>
                {/* Modal Header matching your existing style */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        Resolution Details
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose />
                    </button>
                </div>

                <div className="staff-form-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    {/* Meeting Information Header */}
                    <div className="flex flex-col md:items-center gap-2 mb-6 mt-2">
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label" style={{ marginBottom: 0 }}>
                                Meeting Title :
                            </label>
                            <span className="text-sm font-bold text-gray-800">
                                {resolution.meetingName}
                            </span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label" style={{ marginBottom: 0 }}>
                                Meeting Date :
                            </label>
                            <span className="text-sm text-gray-600">
                                {resolution.meetingDate || "N/A"}
                            </span>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="staff-modal-label" style={{ marginBottom: 0 }}>
                                Meeting Location :
                            </label>
                            <span className="text-sm text-gray-600">
                                {resolution.meetingLocation || "N/A"}
                            </span>
                        </div>
                    </div>

                    {/* Agendas Table - Grouped view of multiple items */}
                    <div className="border border-black rounded-sm overflow-hidden mx-auto mb-4" style={{ width: '95%' }}>
                        <table className="w-full text-sm border-collapse">
                            <thead>
                                <tr className="bg-gray-100 border-b border-black">
                                    <th className="p-2 text-center border-r border-black font-bold w-12">Sr</th>
                                    <th className="p-2 border-r border-black font-bold">Resolution Description</th>
                                    <th className="p-2 text-center font-bold w-48">Attachment</th>
                                </tr>
                            </thead>
                            <tbody>
                                {resolution.resolutionItems && resolution.resolutionItems.length > 0 ? (
                                    resolution.resolutionItems.map((item, index) => (
                                        <tr key={item.id || index} className="border-b border-black last:border-0">
                                            <td className="p-2 text-center border-r border-black">{index + 1}</td>
                                            <td className="p-2 pl-4 text-left border-r border-black whitespace-pre-wrap">
                                                {item.resolutionDescription}
                                            </td>
                                            <td className="p-2 text-center">
                                                {item.attachmentUrl ? (
                                                    <a 
                                                        href={resolveMediaUrl(item.attachmentUrl)} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 underline hover:text-blue-800 break-all"
                                                    >
                                                        {item.attachmentName || "View File"}
                                                    </a>
                                                ) : (
                                                    <span className="text-gray-400 italic">No File</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="p-4 text-center text-gray-500 italic">
                                            No agenda items found for this meeting.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer matching your Save button style */}
                <div className="staff-form-footer">
                    <button className="staff-btn-save" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewResolutionDetailsModal;